import { render, staticRenderFns } from "./WardInboundMessageList.vue?vue&type=template&id=1a48aac7&"
import script from "./WardInboundMessageList.vue?vue&type=script&lang=js&"
export * from "./WardInboundMessageList.vue?vue&type=script&lang=js&"
import style0 from "./WardInboundMessageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports